import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { LegalPersonTags } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export type IconVariant = 'bulls-eye' | 'money-v3' | 'user-profile';

export type ClassifierOption = {
	label: string;
	value: string;
	iconVariant?: IconVariant;
};

export const getEntityClassifierBadgeConfig = (
	classifier: string,
	tCapMange: TranslateFunction<I18Namespaces.CAP_MANAGE>
): {
	label: string;
	backgroundColor: string;
	foregroundColor: string;
	iconVariant: IconVariant;
} => {
	switch (classifier) {
		case LegalPersonTags.TARGET:
			return {
				label: tCapMange('tags.target'),
				backgroundColor: 'cyan.2',
				foregroundColor: 'cyan.9',
				iconVariant: 'bulls-eye',
			};
		case LegalPersonTags.FUND:
			return {
				label: tCapMange('tags.fund'),
				backgroundColor: 'violet.2',
				foregroundColor: 'violet.9',
				iconVariant: 'money-v3',
			};
		case LegalPersonTags.CO_INVESTOR:
			return {
				label: tCapMange('tags.co_investor'),
				backgroundColor: 'orange.2',
				foregroundColor: 'orange.9',
				iconVariant: 'user-profile',
			};
		case LegalPersonTags.EXTERNAL_LENDER:
			return {
				label: tCapMange('tags.external_lender'),
				backgroundColor: 'green.2',
				foregroundColor: 'green.9',
				iconVariant: 'user-profile',
			};
		case LegalPersonTags.BID_CO:
			return {
				label: tCapMange('tags.bid_co'),
				backgroundColor: 'blue.2',
				foregroundColor: 'blue.9',
				iconVariant: 'user-profile',
			};
		case LegalPersonTags.SPV:
			return {
				label: tCapMange('tags.spv'),
				backgroundColor: 'red.2',
				foregroundColor: 'red.9',
				iconVariant: 'user-profile',
			};
		case LegalPersonTags.PC_MANAGED:
			return {
				label: tCapMange('tags.pc_managed'),
				backgroundColor: 'grape.2',
				foregroundColor: 'grape.9',
				iconVariant: 'user-profile',
			};
		default:
			return {
				label: classifier,
				backgroundColor: 'gray.4',
				foregroundColor: 'dark.4',
				iconVariant: 'user-profile',
			};
	}
};
